export class DirectoryHealthCareProviderSearchDuplicateDto {
    public licenseOrganizationRuleId: string;
    public licenseNumber: string;

    public constructor(init?: Partial<DirectoryHealthCareProviderSearchDuplicateDto>) {
        Object.assign(this, init);
    }
}
